import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../../Styles/Integration.css";


export default function SwitchExample() 
{
  const [isOnlinePaymentActive, setIsOnlinePaymentActive] = useState(true);
  const [isCashlessSettingActive, setIsCashlessSettingActive] = useState(true);
  const [isSMSgatewayActive, setIsSMSgatewayActive] = useState(true);

  return (
    <>
    
      {/* Online Payment Settings */}
        <div className="special-header  bg-white d-flex justify-content-between align-items-center mt-4 mb-4">
          <h4 className=" page-title">Integration Settings</h4>
          <Link to="" type="button" className="btn custom-btn">Save change</Link>
        </div>
      <div className="card integra-back">
        <div className="border p-3 mb-4 rounded">
          <h6>Payment Settings</h6>
          <div className="d-flex align-items-center mb-3">
            <div className="form-check form-switch me-2">
              <input className="form-check-input" type="checkbox" id="onlinePayment" checked={isOnlinePaymentActive}
                onChange={(e) => setIsOnlinePaymentActive(e.target.checked)} />
            </div>
            <label className="form-check-label mb-0" htmlFor="onlinePayment">
              {isOnlinePaymentActive ? "Disable Online Payment" : "Activate Online Payment"}
            </label>
          </div>
        

        {/* Show details only if Online Payment is active */}
        {isOnlinePaymentActive && (
          <div className="row mb-3">
            <div className="col-md-6 mb-2">
              <label className="form-label">Payment Gateway<span className="text-danger">*</span> </label>
              <select className="form-select" defaultValue="">
                <option value="">RazorPay</option>
                <option>Paypal</option>
                <option>PayTm</option>
                <option>Gpay</option>
                <option>PhonePay</option>
                <option>BharatPay</option>
              </select>
            </div>
            <div className="col-md-6 mb-2">
              <label className="form-label">Payment Gateway Merchant ID</label>
              <input type="text" className="form-control" placeholder="208447" />
            </div>
            <div className="col-md-6 mb-2">
              <label className="form-label">Payment Gateway Key ID</label>
              <input type="text" className="form-control" placeholder="AVRG87GH35BW91GRWB" />
            </div>
            <div className="col-md-6 mb-2">
              <label className="form-label">Payment Gateway Key Secret</label>
              <input type="text" className="form-control" placeholder="0A2AF8054EF3128611119953AD8D355E" />
            </div>
            <div className="col-md-6 mb-2">
              <label className="form-label">Payment Gateway Transaction Charge(%)</label>
              <input type="text" className="form-control" placeholder="0" />
            </div>
            <div class="col-md-6 form-check form-switch mt-5 measurement">
              <input class="form-check-input" type="checkbox" id="flexSwitchCheckChecked" />
              <label class="form-check-label" for="flexSwitchCheckChecked">Payment Gateway Account</label>
            </div>
          </div>
          
        )}
        </div>

        {/* Cashless Settings */}
        <div className="border p-3 mb-4 rounded">
          <h6>Cashless Settings</h6>
          <div className="d-flex align-items-center mb-3">
            <div className="form-check form-switch me-2">
              <input
                className="form-check-input" type="checkbox" id="cashless"
                checked={isCashlessSettingActive}
                onChange={(e) => setIsCashlessSettingActive(e.target.checked)} />
            </div>
            <label className="form-check-label mb-0" htmlFor="cashless">
              {isCashlessSettingActive ? "YES" : "NO"}
            </label>
            <span className="ms-2">Cashless Card For Store</span>
          </div>

          {/* Show details only if Cashless is active */}
          {isCashlessSettingActive && (
            <div className="row mb-3">
              <div className="col-md-6 mb-2">
                <label className="form-label">Maximum Balance ($)</label>
                <input type="number" className="form-control" placeholder="25000" />
              </div>
              <div className="col-md-6 mb-2">
                <label className="form-label">Minimum Balance ($)</label>
                <input type="number" className="form-control" placeholder="10" />
              </div>
              <div className="col-md-6 mb-2">
                <label className="form-label">
                  Maximum no of transactions per day per card
                </label>
                <select className="form-select" placeholder="no limit">
                  <option>no limit</option>
                </select>
              </div>
              <div className="col-md-6 mb-2">
                <label className="form-label">Maximum spend per day per card ($)</label>
                <input type="text" className="form-control" />
              </div>
            </div>
          )}
        </div>
        {/* SMS Gateway Settings */}
        <div className="border p-3 mb-4 rounded">
          <h6>SMS Gateway</h6>
          <div className="d-flex align-items-center mb-3">
            <div className="form-check form-switch me-2">
              <input
                className="form-check-input" type="checkbox" id="cashless"
                checked={isSMSgatewayActive}
                onChange={(e) => setIsSMSgatewayActive(e.target.checked)} />
            </div>
            <label className="form-check-label mb-0" htmlFor="SMSGateway">
              {isSMSgatewayActive ? "ENABLED" : "DISABLED"}
            </label>
            <span className="ms-2">Cashless Card For Store</span>
          </div>

          {/* Show details only if SMS Gateway is active */}
          {isSMSgatewayActive && (
            <div className="row mb-3">
              <div className="col-md-6 mb-2">
                <label className="form-label">SMS Gateway</label>
                <select className="form-select" placeholder="Select SMS Gateway">
                  <option>infoneysolutions</option>
                  <option>textlocal</option>
                  <option>smsto</option>
                  <option>messagebird</option>
                  <option>mysmsmantra</option>
                  <option>advanta</option>
                </select>
              </div>
              <div className="col-md-6 mb-2">
                <label className="form-label">SMS Gateway Username </label>
                <input type="text" className="form-control" placeholder="bb8fe3311bf31a4f612cb475d111e741" />
              </div>
              <div className="col-md-6 mb-2">
                <label className="form-label">SMS Gateway Password </label>
                <input type="text" className="form-control" placeholder="2571" />
              </div>
              <div className="col-md-6 mb-2">
                <label className="form-label">SMS Gateway Sender ID</label>
                <input type="text" className="form-control" placeholder="INFONEY_LTD" />
              </div>
              
            </div>
           

          )}
        </div>
        <div className="col-md-12 ">
            <div className=" d-flex justify-content-end gap-2">
                <Link to="" type="button" class="btn custom-btn ">Sign-Up</Link>
                 <Link to="" type="button" class="btn custom-btn recharge">Recharge</Link>
                </div>
              </div>
              

      </div>
    </>
  );
}
